import { Directive, HostListener } from '@angular/core';
import { LayoutService } from 'src/app/_core/services/layout.service';
import { SubscriptionManager } from 'src/app/_core/tools/subscription-manager';

@Directive({
    selector: '[appNavigateHome]',
    standalone: false
})
export class NavigateHomeDirective extends SubscriptionManager {

    constructor(private layoutService: LayoutService) {
        super();
    }

    @HostListener('click')
    navigation(): void {
        this.watch$ = this.layoutService.navigateToHome();
    }

}
